// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectLabel } from '@weezevent/nacre';
import { FormComponent } from './formComponents';

export default function SelectField({ label, value, onChange = () => {}, options, params }) {
    const { t } = useTranslation();
    const [componentType, setComponentType] = React.useState(value?.type);

    // Todo: Need to find a better way to have the correct type
    React.useEffect(() => {
        if (value && value.type) setComponentType(value.type);
    }, [value]);

    const labelParams = React.useMemo(() => {
        const _params = { ...params };
        delete _params.params_options;
    }, [params]);

    return (
        <>
            <SelectLabel
                useNew
                label={label}
                options={options}
                value={componentType}
                placeholder={t('ticket.common.action.select')}
                onChange={selected => {
                    setComponentType(selected);
                    const nullValue = selected === 'number' ? 0 : selected === 'boolean' ? false : null;
                    onChange({ value: nullValue, type: selected });
                }}
                onClear={() => {
                    setComponentType(null);
                    //we keep the key value to clear the translations
                    onChange({ value: null, type: null });
                }}
                {...labelParams}
            />
            {componentType && (
                <FormComponent
                    type={componentType}
                    defaultValue={value?.type === componentType ? value?.value : ''}
                    onChange={newValue => {
                        onChange({ value: newValue, type: componentType });
                    }}
                    params={params?.params_options ? params.params_options[componentType] : {}}
                />
            )}
        </>
    );
}
